export const healthScore_v1 = [
  {
    breakerId: 'EvG',
    additionalData: {
      healthRemaining: 391100,
    },
    position: 0,
  },
  {
    breakerId: 'PRIMAPRIMAPRIMA',
    additionalData: {
      healthRemaining: 370330,
    },
    position: 1,
  },
  {
    breakerId: 'svinya123',
    additionalData: {
      healthRemaining: 322480,
    },
    position: 2,
  },
  {
    breakerId: 'Mixelz',
    additionalData: {
      healthRemaining: 312563,
    },
    position: 3,
  },
  {
    breakerId: 'aracern',
    additionalData: {
      healthRemaining: 302450,
    },
    position: 4,
  },
  {
    breakerId: 'TopGun',
    additionalData: {
      healthRemaining: 286421,
    },
    position: 5,
  },
  {
    breakerId: 'KOLIMA',
    additionalData: {
      healthRemaining: 254384,
    },
    position: 6,
  },
  {
    breakerId: 'Buterin',
    additionalData: {
      healthRemaining: 245100,
    },
    position: 7,
  },
  {
    breakerId: 'RAVI',
    additionalData: {
      healthRemaining: 98447,
    },
    position: 8,
  },
  {
    breakerId: 'Kris',
    additionalData: {
      healthRemaining: 64670,
    },
    position: 9,
  },
];
